import type { ReactNode } from 'react';
import { Html } from './Html';

interface Props {
  heading: string | null;
  paragraph?: string | null;
  children: ReactNode;
  id?: string;
}

/** A card with the tenant's heading (from /booking/form) and optional paragraph. */
export function Section({ heading, paragraph, children, id }: Props) {
  return (
    <section className="cbf-card" id={id} aria-label={heading ?? undefined}>
      {heading || paragraph ? (
        <div className="cbf-section-head" style={{ float: 'none' }}>
          {heading ? <h2 className="cbf-h2">{heading}</h2> : null}
          {paragraph ? <Html as="p" className="cbf-p" html={paragraph} /> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
